import React, { useEffect, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  FormControl,
  FormLabel,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  RadioGroup,
  Radio,
  OutlinedInput,
  //Import Select and MenuItem for dropdown
  Select,
  MenuItem,
} from "@mui/material";
import dayjs from "dayjs";
import { useMenteeContext } from "../../context/MenteeContext";
import {
  CustomDialogTitle,
  CustomRadioGroupLabel,
  Loading,
} from "../../components";
import { Breakpoint } from "../../utils/theme";
import { currentQuater, getQuarterEndDate } from "../../utils/validation";
import moment from "moment/moment";
import {
  createMeetingScheduler,
  updateMeetingSchedulerCount,
} from "../../utils/services";
import { useUserContext } from "../../context/UserContext";
import { statusType } from "../../constants/constants";
import { enqueueSnackbar } from "notistack";

// RESCHEDULE_REASONS list with frontend label and database value
const RESCHEDULE_REASONS = [
  {
    label:
      "Conflicting meetings: An urgent, last-minute function or stakeholder meeting was called.",
    value: "Conflicting meeting",
  },
  {
    label:
      "A scheduling error occurred where two observations or events overlap.",
    value: "Schedule overlap",
  },
  {
    label: "Problems with the FSS App, or remote login credentials.",
    value: "FSS App / login issue",
  },
  {
    label: "Unplanned Leave taken by Facilitator on the CO Day",
    value: "Facilitator on unplanned leave",
  },
  {
    label: "Unplanned leave taken by the FSC on the CO Day",
    value: "FSC on unplanned leave",
  },
  {
    label: "Low student attendance",
    value: "Low student attendance",
  },
  {
    label:
      "Change in session plan: Practical/field visit/Guest/SME session planned in place of classroom session",
    value: "Session plan changed",
  },
  {
    label:
      "Environmental disruptions: Loud construction, power outages, or facility issues making the environment unsuitable.",
    value: "Environmental / facility issue",
  },
  {
    label:
      "Scope adjustment: The observer decided to wait until a different phase of the course to better evaluate specific competencies.",
    value: "Scope adjustment",
  },
  {
    label: "Others",
    value: "Others",
  },
];

const RESCHEDULE_LIMIT = 2;
const RESCHEDULE_REASON_MIN_LENGTH = 15;
const RESCHEDULE_MIN_DAYS = 7;
const LAST_MONTH_CUTOFF_DAY = 25;
const LAST_MONTH_EXCEPTION_START_DAY = 18;
const ERROR_RESCHEDULE_LIMIT  ="This meeting has already been rescheduled 2 times. You cannot reschedule it again.";
const SELECT_REASON ="Please select a reschedule reason.";
const OTHER_REASON ="Please specify the reschedule reason (minimum 15 characters).";
const WARNING_FINAL_RESCHEDULE ="You are using your final reschedule. After this, this meeting cannot be rescheduled again.";
const SOMETHING_WENT_WRONG ="Something went wrong. Please try again later.";

function ScheduleForm({ open, setOpen, batchName, moduleName }) {
  // initialize with null instead of undefined 
  const [date, setDate] = useState(null);
  const [type, setType] = useState("");
  const [loading, setLoading] = useState(false);

  // State for dropdown and other reason
  const [selectedReason, setSelectedReason] = useState("");
  const [otherReason, setOtherReason] = useState("");

  const { mentee, scheduleList, getMenteeSchedules, clearMenteeData } =
    useMenteeContext();
  const { user } = useUserContext();
  const quarter = currentQuater();

  const handleClose = () => {
    setOpen(false);

    // use null instead of undefined 
    setDate(null);
    setType("");

    // Reset reschedule reason state 
    setSelectedReason("");
    setOtherReason("");
  };

  const handleSave = async () => {
    if (!mentee) return;

    setLoading(true);
    let msg = "";
    let variant = "success";
    let isNew = true;
    let response;

    let updateData = {
      scheduleDate: moment(date.$d).format("YYYY-MM-DD"),
      scheduleFor: type,
      sessionStatus: mentee.status,
    };

    if (updateData.sessionStatus == statusType.Pending) {
      updateData.sessionStatus = statusType.Scheduled;
      const data = {
        ...updateData,
        menteeId: `${mentee.id}`,
        quaterName: quarter,
        programId: mentee.programId,
        createdBy: user.id,
        updatedBy: user.id,
        batchName: batchName,
        moduleName: moduleName,
        primaryDomain: mentee.primaryDomain,
        specialization: mentee.specialization,
      };
      console.log(data);

      isNew = true;
      response = await createMeetingScheduler(user.token, data);
    } else if (
      updateData.sessionStatus == statusType.Scheduled ||
      updateData.sessionStatus == statusType.Rescheduled
    ) {
      let finalReason = selectedReason;

      if (!selectedReason) {
        enqueueSnackbar(SELECT_REASON, {
          variant: "error",
        });
        setLoading(false);
        return;
      }

      if (selectedReason === "Others") {
        if (!otherReason || otherReason.trim().length < RESCHEDULE_REASON_MIN_LENGTH) {
          enqueueSnackbar(
            OTHER_REASON,
            {
              variant: "error",
            },
          );
          setLoading(false);
          return;
        }

        finalReason = `Others: ${otherReason.trim()}`;
      }

      updateData.sessionStatus = statusType.Rescheduled;

      let schedule = scheduleList.filter(
        (schedule) => schedule.menteeId == mentee.id,
      )[0];

if (schedule.rescheduleCount >= RESCHEDULE_LIMIT) {
  enqueueSnackbar(
    ERROR_RESCHEDULE_LIMIT,
    {
      variant: "error",
    }
  );
  setLoading(false);
  return;
}

   let history = [];

if (schedule.rescheduleReason) {
  try {
    history = JSON.parse(schedule.rescheduleReason);
  } catch (error) {
    history = [];
  }
}

history.push({
  RescheduleId: (schedule.rescheduleCount || 0) + 1,
  PrevScheduleDate: schedule.scheduleDate,
  UpdatedDate: moment().format("YYYY-MM-DD"),
  reason: finalReason,
});


schedule.updatedBy = user.id;

schedule = {
  ...schedule,
  ...updateData,
  rescheduleCount: (schedule.rescheduleCount || 0) + 1,
  rescheduleReason: JSON.stringify(history),
  primaryDomain: mentee.primaryDomain,
  specialization: mentee.specialization,
};

      console.log(schedule);
      isNew = false;
      response = await updateMeetingSchedulerCount(
        user.token,
        schedule.id,
        schedule
      );
    } else if (updateData.sessionStatus == statusType.Completed) return;

    if (response.status == 200 || response.status == 201) {
      await getMenteeSchedules();

      variant = "success";
      msg = `Session ${isNew ? "scheduled" : "rescheduled"} for ${
        mentee.name
      } on ${updateData.scheduleDate}`;

      handleClose();
      clearMenteeData();
    } else {
      variant = "error";
      msg =SOMETHING_WENT_WRONG ;
    }
    setLoading(false);
    enqueueSnackbar(msg, { variant });
  };

  const isMob = Breakpoint();
useEffect(() => {
  if (mentee.scheduleDate) {
    setDate(dayjs(mentee.scheduleDate));
  } else {
    setDate(dayjs());
  }

  setType(mentee.scheduleType || "");

  // Warning for final reschedule
  if (open && scheduleList.length) {
    const schedule = scheduleList.find(
      (s) => s.menteeId === mentee.id
    );

    if (
      schedule?.rescheduleCount === 1 &&
      (mentee.status === statusType.Scheduled ||
        mentee.status === statusType.Rescheduled)
    ) {
      enqueueSnackbar(
        WARNING_FINAL_RESCHEDULE ,
        { variant: "warning" }
      );
    }
  }
}, [open, mentee, scheduleList]);
const shouldDisableDate = (selectedDate) => {
  // Sunday disable
  if (selectedDate.day() === 0) {
    return true;
  }

  const currentDate = dayjs().startOf("day");
  const quarterEndMonth = dayjs(endDate).month();

  // Apply to ALL schedules
  if (
    selectedDate.month() === quarterEndMonth &&
    selectedDate.date() > LAST_MONTH_CUTOFF_DAY
  ) {
    return true;
  }

  // Only Reschedule
  if (
    mentee.status === statusType.Scheduled ||
    mentee.status === statusType.Rescheduled
  ) {
    const diff = selectedDate.diff(currentDate, "day");

    if (
      selectedDate.month() === quarterEndMonth &&
      currentDate.date() >= LAST_MONTH_EXCEPTION_START_DAY
    ) {
      return false;
    }

    if (diff < RESCHEDULE_MIN_DAYS) {
      return true;
    }
  }

  return false;
};
  const endDate = getQuarterEndDate();

  return (
    <Dialog onClose={handleClose} open={open} fullScreen={isMob}>
      <CustomDialogTitle onClose={handleClose}>
        Meeting Scheduler For {mentee.name} - {mentee.programName}
      </CustomDialogTitle>
      <DialogContent dividers>
        <FormControl size="small" fullWidth>
          <FormLabel>Schedule Type</FormLabel>
          <RadioGroup
            //  ensure controlled component
            value={type || ""}
            onChange={(e) => setType(e.target.value)}
            name="type"
          >
            <CustomRadioGroupLabel
              disabled={Boolean(mentee.scheduleType)}
              value="Mentoring"
              control={<Radio size="small" />}
              label="Mentoring"
            />

            <CustomRadioGroupLabel
              disabled={Boolean(mentee.scheduleType)}
              value="Observation"
              control={<Radio size="small" />}
              label="Classroom Observation"
            />
          </RadioGroup>
        </FormControl>

        <FormControl margin="normal" size="small" fullWidth>
          <FormLabel>Schedule Date</FormLabel>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={date || null}
              onChange={(newValue) => setDate(newValue)}
              format="YYYY/MM/DD"
              disablePast
              shouldDisableDate={shouldDisableDate}
              // shouldDisableDate={isWeekend}
              maxDate={dayjs(endDate)}
              slotProps={{
                field: {
                  readOnly: true,
                  onKeyDown: (e) => {
                    e.preventDefault();
                  },
                  onPaste: (e) => {
                    e.preventDefault();
                  },
                  onCut: (e) => {
                    e.preventDefault();
                  },
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
        {/*Reschedule reason dropdown */}
        {(mentee.status === statusType.Scheduled ||
          mentee.status === statusType.Rescheduled) && (
          <FormControl margin="normal" size="small" fullWidth required>
            <FormLabel>Reschedule Reason</FormLabel>

            <Select
              value={selectedReason}
              onChange={(e) => setSelectedReason(e.target.value)}
              displayEmpty
            >
              <MenuItem value="">
                <em>Select reason</em>
              </MenuItem>

              {RESCHEDULE_REASONS.map((reason, index) => (
                <MenuItem key={index} value={reason.value}>
                  {reason.label}
                </MenuItem>
              ))}
            </Select>

            {selectedReason === "Others" && (
              <FormControl fullWidth margin="normal">
                <FormLabel>Please specify reschedule reason</FormLabel>

                <OutlinedInput
                  multiline
                  minRows={3}
                  value={otherReason}
                  onChange={(e) => setOtherReason(e.target.value)}
                  placeholder="Enter reason (minimum 15 characters)"
                />
              </FormControl>
            )}
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose} color="error">
          Cancel
        </Button>
        <Button
          variant="contained"
          autoFocus
          disabled={
            type == "" ||
            (mentee.scheduleType == ""
              ? false
              : mentee.scheduleDate == moment(date.$d).format("YYYY-MM-DD"))
          }
          onClick={handleSave}
          color="success"
        >
          Save changes
        </Button>
      </DialogActions>

      <Loading open={loading} />
    </Dialog>
  );
}

export default ScheduleForm;
